<template>
  <div class="agreement-container">
    <h1>{{ title }}</h1>
    <div class="agreement-content">
      <div v-if="type === 'privacy'">
        <div class="policy-header">
          <h2>煜家通智能隐私政策</h2>
          <p>最新版本生效时间: 2026年3月25日</p>
        </div>
        
        <div class="policy-tip">
          <h3>提示条款</h3>
          <p>应用运营方: 郑州煜家通智能科技有限公司</p>
          <p>煜家通智能产品和/或服务是由郑州煜家通智能科技有限公司(以下简称"我们"或"煜家通智能")提供。我们非常重视您的个人信息和隐私保护，我们将会按照法律要求为您的个人信息提供相应的安全保护措施。</p>
          <p>在使用煜家通智能产品和/或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后开始使用相关产品或服务。我们将通过本隐私政策向您介绍不同场景下我们如何处理个人信息。当您登录煜家通智能时，为实现您选择使用的功能、服务，或为遵守法律法规的要求，我们会处理相关信息。除实现煜家通智能产品和/或服务的基本功能和服务所需的信息，和根据法律法规要求所必需的信息之外，您可以拒绝我们处理其他信息，但这可能导致我们无法提供对应的煜家通智能产品和/或服务。我们将在本政策中逐项说明相关情况，有关您个人信息权益的重点内容我们已采用粗体标示，同时，对于个人敏感信息，我们用"加粗斜体"的书写方式进行特别提醒，希望您在阅读时特别关注。我们将为您提供访问、更正、删除、注销等信息保护方式。</p>
        </div>
        
        <div class="policy-section">
          <h3>一、我们向您收集的个人信息及其用途</h3>
          <p>个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。我们会出于本政策所述的以下目的，收集和使用您的个人信息:</p>
          
          <p>在您注册"煜家通智能"账号时，您需要提供手机号码创建账号，并完善相关的网络身份识别信息(如昵称、登陆密码等)。若您愿意额外补充如下个人信息，将有助于我们为您提供更为个性化的服务:包括您的姓名、联系方式等。</p>
          
          <p>在您注册与使用服务过程中，您选择上传的或自主自愿拍摄的头像照片，我们将收集并用于为您创建"煜家通智能"的账号头像。</p>
          
          <p>在注册与使用服务过程中，若您愿意额外补充生日、性别、个性签名等个人资料，将有助于"煜家通智能"为您提供更为个性化的服务。但如果您不提供这些信息，将不会影响使用"煜家通智能"产品或服务的基本功能。</p>
          
          <p>为了提供禽舍环境管理功能，我们会收集禽舍内的温度、湿度、压差等环境数据，用于远程控制和监控禽舍环境。</p>
          
          <p>我们会根据您在安装及使用"煜家通智能"软件及相关服务的过程中授予的具体权限收集您所使用的设备相关信息(例如设备型号、操作系统版本、设备配置、设备标识、设备网络信息、设备环境，软件列表等软硬件特征信息)，用于向您提供更契合您需求的信息展示和搜索结果，以及了解产品适配性、识别账号异常状态。</p>
          
          <p>当您使用我们提供的产品和/或服务时，我们会收集您使用"煜家通智能"软件时浏览、搜索、收藏、交易等信息并作为有关网络日志进行保存(包括您使用软件及相关服务的日期、时间、IP地址、电信运营商、网络请求等)，用于识别账号异常状态及满足相关法律法规的要求;同时，经您授权我们会收集您在使用我们产品和/或服务过程中产生的包括位置信息在内的相关信息。</p>
        </div>
        
        <div class="policy-section">
          <h3>二、我们如何使用收集的信息</h3>
          <p>在符合法律法规的前提下，为了保障您的账号安全以及为您提供更优质的服务，我们会收集和使用您在使用煜家通智能产品与/或服务过程中产生的如下信息:</p>
          
          <h4>2.1 设备信息</h4>
          <p>为了使煜家通智能APP与您的移动设备进行必要的适配，为您提供安全、可信的产品与使用环境，保障APP的安全运行，在您使用煜家通智能APP时，根据您在软件安装及使用中授予的具体权限，我们会收集您的设备型号、设备识别码(包括IMEI/Android ID/IDFA/IDFV/OPEN UDID/GUID/OAID/SN ID/MEID、广告ID、SIM卡手机号、IMSI、ICCID)、软件列表、设备运行状态信息、系统版本、MCC、MNC、Mac地址信息(包括手机Mac地址和蓝牙Mac地址)、设备传感器信息。收集这些信息是为了帮助我们进行bug分析、反作弊、反黑产等安全保护工作，保障您正常使用本产品与/或服务、改进和优化我们的产品体验、保障您的账号安全。同时，除本政策另有明确约定外，我们不会将您的设备信息提供给任何第三方，但我们无法保证其他第三方不会通过其他途径获知您设备信息、并将您的设备信息与其他信息相结合识别您个人身份，由此造成您任何损失的，您应向该第三方主张赔偿。上述设备信息是为提供服务所收集的基础信息，如您不想将上述设备信息被我们收集，则可能导致我们无法向您提供正常的服务。</p>
          
          <h4>2.2 日志信息</h4>
          <p>当您使用煜家通智能产品与/或服务时，我们会收集您的相关网络日志信息，包括程序崩溃、系统活动信息、设备联网情况、浏览记录、点击记录、软件使用记录及IP地址信息。我们收集上述信息是为了能更好的用于安全维护及优化本产品与/或服务，为您提供更好的使用体验。上述日志信息是为提供服务所收集的基础信息，如您不想将上述日志信息被我们收集，则可能导致我们无法向您提供正常的服务。</p>
          
          <h4>2.3 地理位置信息</h4>
          <p>当您同意开启您的位置权限后，我们会收集您的地理位置信息，用于在您使用系统时展示您的位置信息，或为您提供与位置相关的服务。如果您拒绝我们收集此类信息，前述相关功能将无法正常使用，但不影响您使用煜家通智能APP的其他功能。</p>
          
          <h4>2.4 消费记录信息</h4>
          <p>在您使用本产品提供的第三方支付功能进行消费时，我们会收集并保存您的消费记录信息、订单信息、对账信息，用于确认您的支付指令并帮助您完成支付，同时，此类信息还将作为您消费的凭证。</p>
          
          <h4>2.5 煜家通智能APP所调用的系统权限</h4>
          <p>如上所述，为了向您提供煜家通智能产品与/或服务，我们可能需要使用您设备中的系统权限(不包括所接入第三方调用的权限)来收集相关个人信息。尽管我们在前述章节中已经有所涉及，本节将对煜家通智能所使用的所有系统权限进行归纳整理，以方便向您更加系统、完整、透明地呈现。您可以选择是否授权我们使用您设备的相关权限，如果您不授权我们使用相关权限，可能会导致部分服务无法使用，但是不影响您使用煜家通智能的其他功能。</p>
          
          <h5>2.5.1 相册及存储权限</h5>
          <p>当您同意开启此项权限后，我们会使用您设备上的相册读取及存储功能。此项功能将用于为您上传设备内的文本、图像、视频等内容，也可缓存您使用煜家通智能产品与/或服务过程中产生的文本、图像、视频内容。请您知悉，我们不会自动读取您本地相册的存储内容，仅在您同意开启此权限并在相册中主动选择相应图片后才会获取图片/视频数据。如果您拒绝该项授权，前述功能将无法正常使用。</p>
          
          <h5>2.5.2 麦克风权限</h5>
          <p>当您同意开启此项权限后，我们会使用您设备上的麦克风功能，并会识别您上传的语音信息。此项权限将用于实现语音输入，并采集、识别上述功能实现过程中所输入的语音信息。如果您拒绝该项授权，前述功能将无法使用。</p>
          
          <h5>2.5.3 消息推送权限</h5>
          <p>当您同意开启此项权限后，我们会为您推送消息，便于您能够及时接收及了解我们发出的通知。如您拒绝此项授权，您将无法接收到我们为您推送的消息。</p>
          
          <h5>2.5.4 摄像头权限</h5>
          <p>当您同意开启此项权限后，我们会使用您设备上的相机拍摄功能。此项功能将用于实现照片拍摄、录制视频功能，并采集、识别上述功能实现过程中所拍摄或录制的图片及视频信息。如您拒绝该项授权，前述功能将无法使用。</p>
          
          <h5>2.5.5 地理位置权限</h5>
          <p>当您同意开启此项权限后，我们会收集您的地理位置信息用于在您使用系统时展示您的位置信息，或为您提供与位置相关的服务。如果您拒绝此类授权，上述功能将无法实现。</p>
          
          <h5>2.5.6 设备信息访问权限</h5>
          <p>当您同意开启此项权限后，为了保护您的账户及登录安全，我们会收集您的相应设备信息，用于优化用户体验、安全排查、识别是否为常用设备、设备绑定情况。收集 MAC 地址是为了实现设备识别和安全验证，收集软件安装列表是为了查找三方软件如微信是否安装并正确分享。若您是安卓系统用户，您拒绝该项授权将导致您无法正常使用本产品与/或服务。若您是iOS系统用户，受iOS系统限制，您可能无法直接拒绝或关闭上述授权，但针对部分设备信息(例如:IDFA信息，具体以iOS系统政策不时更新的实际情况为准)，您可以自行选择是否授权我们进行收集，如您拒绝授权，我们可能无法为您提供对应的功能或服务(如:您拒绝我们收集您的IDFA信息，我们将无法基于IDFA追踪标识为您提供个性化展示)。</p>
          
          <p>收集MAC地址目的：是为了实现设备识别和安全验证收集软件安装列表的目的：是为了查找三方软件如微信是否安装并正确分享。APP及三方sdk收集设备MAC地址、设备号：用于区分设备类型；APP及三方sdk收集设备列表：用于判断用户手机有无微信、支付宝； BuglySDK用于崩溃日志收集崩溃日志、唯一设备识别码；友盟统计SDK用于数据统计及分析 软件使用和点击记录、唯一设备识别码、设备MAC地址、IP地址；微信分享SDK 用于分享App； 个推SDK 用于消息推送 设备MAC地址、唯一设备识别码、IP地址;收集用户Wi-Fi SSID、Wi-Fi BSSID、设备序列号、Android_ID 的目的是为了进行功能锚点（设备锚点、功能锚点、网络锚点、版本锚点）记录；</p>
          
          <p>第三方SDK基本信息：</p>
          <p>1.友盟+社会化分享SDK：</p>
          <p>SDK类型：社交类</p>
          <p>SDK名称：友盟+社会化分享SDK</p>
          <p>SDK开发者：友盟同欣（北京）科技有限公司</p>
          <p>SDK隐私链接： `https://www.umeng.com/page/policy`</p>
          <p>2.Bugly Android：</p>
          <p>SDK类型：性能监控类</p>
          <p>SDK名称：Bugly Android</p>
          <p>SDK开发者：深圳市腾讯计算机系统有限公司</p>
          <p>SDK隐私链接： `https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56`</p>
        </div>
        
        <div class="policy-section">
          <h3>三、信息存储和保护</h3>
          <p>存储方式：我们将收集的信息存储在安全的服务器上，并采取适当的技术和管理措施保护这些信息。</p>
          <p>存储期限：我们会根据法律法规的要求和业务需要存储收集的信息，当信息不再需要时，我们会删除或匿名化处理这些信息。</p>
          <p>保护措施：我们采取加密、访问控制、备份等措施保护收集的信息，防止信息泄露、篡改或丢失。</p>
        </div>
        
        <div class="policy-section">
          <h3>四、信息共享</h3>
          <p>我们不会向第三方出售、出租或分享您的个人信息，除非获得您的明确同意。</p>
          <p>我们可能会与我们的服务提供商、合作伙伴共享必要的信息，以提供和改进我们的服务。</p>
          <p>我们可能会根据法律法规的要求向政府部门、监管机构或其他有权机构提供信息。</p>
        </div>
        
        <div class="policy-section">
          <h3>五、您的权利</h3>
          <p>访问权：您有权访问我们收集的关于您的个人信息。</p>
          <p>修改权：您有权修改我们收集的关于您的个人信息。</p>
          <p>删除权：您有权要求我们删除我们收集的关于您的个人信息。</p>
          <p>拒绝权：您有权拒绝我们收集和使用您的个人信息，但这可能会影响您使用本系统的某些功能。</p>
        </div>
        
        <div class="policy-section">
          <h3>六、隐私政策的变更</h3>
          <p>我们可能会根据法律法规的要求或业务需要更新本隐私政策。当我们更新隐私政策时，我们会通过App通知您，并在App中发布更新后的隐私政策。</p>
        </div>
        

      </div>
      
      <div v-else-if="type === 'user'">
        <div class="policy-header">
          <h2>煜家通智能用户协议</h2>
          <p>最新版本生效时间: 2026年3月25日</p>
        </div>
        
        <div class="policy-tip">
          <h3>提示条款</h3>
          <p>欢迎使用煜家通智能产品和/或服务！</p>
          <p>本协议是您与郑州煜家通智能科技有限公司（以下简称"我们"或"煜家通智能"）之间关于使用煜家通智能产品和/或服务的法律协议。在使用煜家通智能产品和/或服务前，请您务必仔细阅读并透彻理解本协议，在确认充分理解并同意后开始使用相关产品或服务。</p>
        </div>
        
        <div class="policy-section">
          <h3>一、总则</h3>
          <p>1.1 煜家通智能产品和/或服务是由郑州煜家通智能科技有限公司提供的禽舍智能管理服务，包括但不限于远程控制温度、压差等环境指令。</p>
          <p>1.2 本协议构成您与我们之间关于使用煜家通智能产品和/或服务的完整协议，取代之前所有关于使用煜家通智能产品和/或服务的口头或书面协议。</p>
          <p>1.3 您在使用煜家通智能产品和/或服务时，应遵守法律法规、社会公德以及本协议的规定。</p>
        </div>
        
        <div class="policy-section">
          <h3>二、用户注册与账号管理</h3>
          <p>2.1 您需要注册一个账号才能使用煜家通智能的全部功能。</p>
          <p>2.2 您应提供真实、准确、完整的个人信息，并在信息变更时及时更新。</p>
          <p>2.3 您应妥善保管您的账号和密码，对使用您账号的所有行为负责。</p>
          <p>2.4 如果您发现账号被他人非法使用，应立即通知我们。</p>
        </div>
        
        <div class="policy-section">
          <h3>三、用户权利与义务</h3>
          <p>3.1 您有权使用煜家通智能提供的各项功能和服务。</p>
          <p>3.2 您应遵守法律法规和本协议的规定，不得利用煜家通智能从事任何违法违规行为。</p>
          <p>3.3 您应尊重他人的合法权益，不得利用煜家通智能侵犯他人的知识产权、名誉权等合法权益。</p>
          <p>3.4 您应合理使用煜家通智能，不得干扰系统的正常运行。</p>
        </div>
        
        <div class="policy-section">
          <h3>四、系统功能与服务</h3>
          <p>4.1 煜家通智能提供禽舍环境管理功能，包括远程控制温度、压差等环境指令。</p>
          <p>4.2 我们有权根据业务需要调整、更新或停止部分功能和服务。</p>
          <p>4.3 我们会尽力确保系统的稳定运行，但不保证系统不会出现故障或中断。</p>
        </div>
        
        <div class="policy-section">
          <h3>五、知识产权</h3>
          <p>5.1 煜家通智能的所有内容，包括但不限于文字、图片、音频、视频、软件等，均受知识产权法律法规的保护。</p>
          <p>5.2 未经我们书面许可，您不得复制、修改、传播或使用煜家通智能的任何内容。</p>
        </div>
        
        <div class="policy-section">
          <h3>六、违约责任</h3>
          <p>6.1 如果您违反本协议的规定，我们有权采取相应的措施，包括但不限于警告、暂停或终止您的账号、要求赔偿损失等。</p>
          <p>6.2 如果我们违反本协议的规定，给您造成损失的，我们应承担相应的赔偿责任。</p>
        </div>
        
        <div class="policy-section">
          <h3>七、协议的变更与终止</h3>
          <p>7.1 我们有权根据法律法规的要求或业务需要变更本协议。</p>
          <p>7.2 如果您违反本协议的规定，我们有权终止本协议。</p>
          <p>7.3 本协议终止后，您应立即停止使用煜家通智能。</p>
        </div>
        
        <div class="policy-section">
          <h3>八、法律适用与争议解决</h3>
          <p>8.1 本协议的订立、履行、解释及争议解决均适用中华人民共和国法律。</p>
          <p>8.2 如因本协议发生争议，双方应协商解决；协商不成的，任何一方均有权向有管辖权的人民法院提起诉讼。</p>
        </div>
        
        <div class="policy-section">
          <h3>九、其他条款</h3>
          <p>9.1 本协议的任何条款被视为无效或不可执行的，不影响其他条款的有效性和可执行性。</p>
          <p>9.2 我们对本协议拥有最终解释权。</p>
        </div>
      </div>
      
      <div v-else-if="type === 'disclaimer'">
        <div class="policy-header">
          <h2>煜家通智能免责声明</h2>
          <p>最新版本生效时间: 2026年3月25日</p>
        </div>
        
        <div class="policy-tip">
          <h3>提示条款</h3>
          <p>欢迎使用煜家通智能产品和/或服务！</p>
          <p>本免责声明是您与郑州煜家通智能科技有限公司（以下简称"我们"或"煜家通智能"）之间关于使用煜家通智能产品和/或服务的免责声明，是用户协议的重要组成部分。</p>
        </div>
        
        <div class="policy-section">
          <h3>一、免责声明</h3>
          <p>1.1 煜家通智能仅作为工具提供给用户使用，我们不对用户使用本系统的结果承担任何责任。</p>
          <p>1.2 我们尽力确保煜家通智能的准确性和可靠性，但不保证本系统提供的信息和数据的准确性、完整性和及时性。</p>
          <p>1.3 由于技术故障、网络问题、自然灾害等不可抗力因素导致煜家通智能无法正常运行或数据丢失，我们不承担任何责任。</p>
        </div>
        
        <div class="policy-section">
          <h3>二、责任限制</h3>
          <p>2.1 我们对因使用煜家通智能而导致的任何直接、间接、偶然、特殊或后果性的损失不承担责任，包括但不限于利润损失、数据损失、业务中断等。</p>
          <p>2.2 我们对因用户违反本协议或法律法规的规定而导致的任何损失不承担责任。</p>
          <p>2.3 我们对因第三方行为而导致的任何损失不承担责任。</p>
        </div>
        
        <div class="policy-section">
          <h3>三、风险提示</h3>
          <p>3.1 用户在使用煜家通智能时应注意网络安全，避免账号和密码泄露。</p>
          <p>3.2 用户应根据实际情况合理使用煜家通智能提供的环境控制功能，避免因操作不当导致的损失。</p>
          <p>3.3 用户应定期备份重要数据，以防止数据丢失。</p>
        </div>
        
        <div class="policy-section">
          <h3>四、其他</h3>
          <p>4.1 本免责声明是煜家通智能用户协议的组成部分，与用户协议具有同等法律效力。</p>
          <p>4.2 本免责声明的任何条款被视为无效或不可执行的，不影响其他条款的有效性和可执行性。</p>
          <p>4.3 我们对本免责声明拥有最终解释权。</p>
        </div>
      </div>
      
      <div v-else>
        <p>请通过URL参数type指定协议类型，可选值：privacy（隐私条款）、user（用户协议）、disclaimer（免责声明）</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  data() {
    return {
      type: 'privacy',
      title: '隐私条款'
    }
  },
  mounted() {
    // 从URL参数中获取协议类型
    const urlParams = new URLSearchParams(window.location.search)
    const type = urlParams.get('type')
    
    if (type) {
      this.type = type
      this.setTitle(type)
    }
  },
  methods: {
    setTitle(type) {
      switch (type) {
        case 'privacy':
          this.title = '隐私条款'
          break
        case 'user':
          this.title = '用户协议'
          break
        case 'disclaimer':
          this.title = '免责声明'
          break
        default:
          this.title = '协议'
      }
    }
  }
}
</script>

<style scoped>
.agreement-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
  font-size: 24px;
}

.policy-header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.policy-header h2 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 20px;
}

.policy-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.policy-tip {
  background-color: #f5f5f5;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 8px;
}

.policy-tip h3 {
  margin: 0 0 15px 0;
  color: #34495e;
  font-size: 16px;
}

.policy-section {
  margin-bottom: 30px;
}

.policy-section h3 {
  margin: 0 0 15px 0;
  color: #34495e;
  font-size: 16px;
  font-weight: bold;
}

p {
  margin-bottom: 15px;
  text-align: justify;
  color: #333;
  font-size: 14px;
}

.agreement-content {
  padding: 20px;
}

/* 加粗样式 */
strong {
  font-weight: bold;
}

/* 加粗斜体样式 */
strong em {
  font-style: italic;
}

h4 {
  margin: 20px 0 10px 0;
  color: #34495e;
  font-size: 15px;
  font-weight: bold;
}

h5 {
  margin: 15px 0 10px 0;
  color: #34495e;
  font-size: 14px;
  font-weight: bold;
}
</style>